/**
*
*   Cart Form Popup
*       - A left/right content block + image or video
*
**/
'use client';

import Preloader from '@/components/preloader';
import Storefront from '@/libraries/shopify/class';
import ProductCard from '@/components/collection/product-card';
import { Tracker } from '@/components/tracker';
import { CartContext } from '@/context/cart';
import { useState, useContext, useEffect } from 'react';
import { useTranslations, useLocale } from 'next-intl';

//Build the Element
export default function CartPopup({ children , product , ...props }){

	//Translations
	const t = useTranslations();

	//Locale
	const locale = useLocale();

	//Is it loading
	const [ loading , setLoading ] = useState(true);

	//Get the Upsell Products
	const [ upsell , setUpsell ] = useState([]);

	//Cart Context
	const { Cart } = useContext(CartContext);

	//Load the Upsell Products
	useEffect(()=>{

		const data = Tracker.sort('product');

		//Only if we have tracked data
		if( data.length > 0 ){
			(async () => {

				//
				const tracked = {
					incart: data.filter( product => product.cart ),
					rest:   data.filter( product => !product.cart )
				};

				//Get the initial product list
				let list = (
					await Storefront.Products.get(
						tracked.rest.map( row => row.id )
					)
				)?.body;

				//If we don't have 3, add the recommendation list
				if( list.length < 3 ) list = list.concat(
					(
						await Storefront.Products.recommendations(
							(
								tracked.incart.length > 0 ?

									//Get Recommendations by most engaged product in cart
									tracked.incart[0].id

								:

									//Get Recommendations based on most interacted
									tracked.rest[0].id
							)
						)
					)?.body
				);

				//Set the Upsell
				setUpsell(
					list.slice( 0 , 3 )
				);

				setLoading(false);

			})();

		}else{
			(async () => {

				//Default to a collection
				const data = ( await Storefront.Collection.load('frontpage') )?.body;

				//Get Product Data
				const products = (
					await Storefront.Products.get(
						data.products.map( (product) => product.id )
					)
				)?.body;

				//Products
				data.products.forEach( (product,i) => {
					products.forEach( productData => {
						if( productData.id == product.id ){
							data.products[i] = { ...data.products[i] , ...productData };
						}
					});
				});

				setUpsell( data.products );

				setLoading(false);

			})();
		}

	},[ Cart.data ]);

	//Return
	return (
		<section id="products" className="container">
			<header>
				<h2>{ t('Pages.Cart.featured.title') }</h2>
			</header>
			<div className="collection">
				<Preloader status={ loading } />
				{upsell.map( (product, i)=>{
					return (
						<ProductCard key={ product.id } product={ product } />
					);
				})}
			</div>
		</section>
	);

}